import CreatePost from './pages/create-post.vue'
import EditPost from './pages/edit-post.vue'
import ListDrafts from './pages/list-drafts.vue'
import ListPosts from './pages/list-posts.vue'
import SinglePost from './pages/single-post.vue'

export default [
  {
    path: '/',
    name: 'home',
    component: ListPosts,
  },
  {
    path: '/v/:id',
    name: 'postById',
    component: SinglePost,
  },
  {
    path: '/create',
    name: 'createPost',
    component: CreatePost,
  },
  {
    path: '/edit/:id',
    name: 'editPostById',
    component: EditPost,
  },
  {
    path: '/my/drafts',
    name: 'myDrafts',
    component: ListDrafts,
  },
]
